<script>
  import { getLoggedIn, getCartCount } from '../../../../../js/stores';
  import { filterNavItems } from '../../../../../js/navItemFilters';

  import ButtonLink from '../../../ButtonLink/ButtonLink.svelte';
  import Link from './Link/Link.svelte';
  import Category from './Category/Category.svelte';

  const loggedInStore = getLoggedIn();
  const cartCountStore = getCartCount();

  export let navItems = [];
  export let cartPrimary = false;

  $: filteredItems = filterNavItems({
    items: navItems,
    loggedIn: $loggedInStore,
    cartCount: $cartCountStore,
  });
</script>

<ul class="NavList" class:cartPrimary>
  {#each filteredItems as item (item)}
    {#if item.type === 'category'}
      <li class="category-item" class:hidden={item.hidden}>
        <Category id={item.id} title={item.title} navItems={item.navItems} spotlightConfig={item.spotlight} />
      </li>
    {:else if item.type === 'link'}
      {#if item.linkStyle === 'primary' || item.linkStyle === 'secondary'}
        <li class="button-item" class:hidden={item.hidden}>
          <ButtonLink id={item.id} title={item.title} url={item.url} linkStyle={item.linkStyle} width="100%" />
        </li>
      {:else}
        <li class="link-item" class:hidden={item.hidden}>
          <Link id={item.id} title={item.title} url={item.url} />
        </li>
      {/if}
    {/if}
  {/each}
</ul>

<style>.NavList {
  display: block;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  list-style-type: none;
  border-bottom: 1px solid var(--color-border, #d9d9d9);
}
.NavList > li {
  display: block;
  position: static;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.NavList > li::before {
  display: none;
}
.NavList li {
  border-width: 0;
  border-style: solid;
  border-color: var(--color-border, #d9d9d9);
}
.NavList .link-item,
.NavList .category-item {
  border-top-width: 1px;
}
.NavList .link-item:first-child,
.NavList .category-item:first-child {
  border-top-width: 0;
}
.NavList .button-item {
  padding-right: 25px;
  padding-left: 25px;
}
.NavList .button-item:first-child {
  padding-top: 25px;
}
.NavList .button-item:last-child {
  padding-bottom: 25px;
}
.NavList .link-item + .button-item,
.NavList .category-item + .button-item {
  padding-top: 25px;
  border-top-width: 1px;
}
.NavList .button-item + .button-item {
  padding-top: 10px;
}
.NavList .button-item + .link-item,
.NavList .button-item + .category-item {
  margin-top: 25px;
}

.cartPrimary .link-item:first-child,
.cartPrimary .category-item:first-child {
  border-top-width: 1px;
}
.cartPrimary .button-item:first-child {
  padding-top: 0;
}</style>
